import type { MessagesType } from '@izimi/modules';
import { notaryMessages } from '@izimi/modules';

const messages = {
  ...notaryMessages,
  notaryClaimVault(name: string): MessagesType {
    return {
      errorMessage: {
        message: ['messages.claimVault.claimVaultFailed', { name }],
      },
      successMessage: {
        message: [
          'messages.claimVault.claimVaultSucceeded',
          {
            name,
          },
        ],
      },
    };
  },
  notaryPassClaimedVault(vaultName: string, notaryName: string): MessagesType {
    return {
      errorMessage: {
        message: ['messages.passClaimedVault.passClaimedVaultFailed', { vaultName, notaryName }],
      },
      successMessage: {
        message: ['messages.passClaimedVault.passClaimedVaultSucceeded', { vaultName, notaryName }],
      },
    };
  },
  notaryAddHeir(name: string): MessagesType {
    return {
      errorMessage: {
        message: ['messages.addHeir.addHeirFailed', { name }],
      },
      successMessage: {
        message: ['messages.addHeir.addHeirSucceeded', { name }],
      },
    };
  },
  notaryDeleteHeir(name: string): MessagesType {
    return {
      errorMessage: {
        message: ['messages.deleteHeir.deleteHeirFailed', { name }],
      },
      successMessage: {
        message: ['messages.deleteHeir.deleteHeirSucceeded', { name }],
      },
    };
  },
  notaryUpdateHeir(name: string): MessagesType {
    return {
      errorMessage: {
        message: ['messages.updateHeir.updateHeirFailed', { name }],
      },
      successMessage: {
        message: ['messages.updateHeir.updateHeirSucceeded', { name }],
      },
    };
  },
  notaryRejectedHeir(name: string): MessagesType {
    return {
      errorMessage: {
        message: ['messages.rejectedHeir.rejectedHeirFailed', { name }],
      },
      successMessage: {
        message: ['messages.rejectedHeir.rejectedHeirSucceeded', { name }],
      },
    };
  },
  notaryTransferClaimedVaultHeirs(count: number): MessagesType {
    return {
      errorMessage: {
        message: ['messages.transferVault.transferVaultHeirsFailed', { count }],
      },
      successMessage: {
        message: ['messages.transferVault.transferVaultHeirsSucceeded', { count }],
      },
    };
  },
  notaryTransferClaimedVaultHeir(name: string): MessagesType {
    return {
      errorMessage: {
        message: ['messages.transferVault.transferVaultHeirsFailed', { name }],
      },
      successMessage: {
        message: ['messages.transferVault.transferVaultHeirSucceeded', { name }],
      },
    };
  },
};

export default messages;
